const PropTypes = require('prop-types')
const React = require('react')
const ReactDOM = require('react-dom')

class Portal extends React.Component {
  constructor(props) {
    super(props)

    this.state = { hydrated: false }
  }

  componentDidMount() {
    if (typeof document === 'object') {
      this.setState(() => ({ hydrated: true }))
    }
  }

  render() {
    // Portals are not supported by ReactDOM.hydrate
    // https://github.com/facebook/react/issues/13097
    if (this.state.hydrated) {
      const containerEl = document.querySelector(this.props.selector)
      return ReactDOM.createPortal(this.props.children, containerEl)
    }
    return null
  }

  static toModalRoot(...children) {
    return React.createElement(Portal, {
      selector: '#modal-root'
    },
      ...children
    )
  }

}

Portal.propTypes = {
  children: PropTypes.node,
  selector: PropTypes.string
}

module.exports = Portal
